import { AXIOS } from "../config/axios.config";
import { IBookingFormInput } from "../components/pages/Booking";

class BookingService {
  async create(data: IBookingFormInput) {
    return await AXIOS.post(`/booking/create`, data);
  }
}
export default new BookingService();
